export default __webpack_public_path__ + "search5dba63.svg";